<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- <bookmarks /> -->
    </div>

    <!-- Right Col -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <SyncCouchDB />
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
      <!-- <cart-dropdown /> -->
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import SyncCouchDB from './app-navbar/SyncCouchDB.vue'
import DarkToggler from './app-navbar/DarkToggler.vue'
import CartDropdown from './app-navbar/CartDropdown.vue'
import UserDropdown from './app-navbar/UserDropdown.vue'


export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    SyncCouchDB,
    DarkToggler,
    CartDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },

}
</script>
